let css = require('./alert.css');
let signals = require('../../../signals/payment');
const { cut } = require('../../../helpers/utils');
let { redirect } = require('../../../signals/utils');

class Alert {
    constructor () {
        this.template = require('./template.hbs');
    }

    render () {
        return this.$context.getWatcherData().then((data) => {
            let { alertType } = data;
            data[alertType] = true;
            return Object.assign({}, data, { css });
        });
    }

    bind () {
        this.$context.signal(signals.onRedirect);
        return {
            click: {
                [cut(css.redirect)]: this.redirect
            }
        };
    }

    redirect (e) {
        e.stopPropagation();
        let url = e.currentTarget.getAttribute('cat-url');
        this.$context.signal(redirect, { url: url });
    }
}

module.exports = {
    constructor: Alert
};



// WEBPACK FOOTER //
// ./components/payment/alert/index.js